import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  OnInit,
  OnDestroy,
  HostListener
} from '@angular/core';
import { LayoutService } from 'src/app/layout/layout.service';

@Directive({
    selector: '[appCustomStyle]',
    standalone: false
})
export class CustomStyleDirective implements OnInit, OnDestroy {
  @Input('appCustomStyle') baseStyles: {
    color?: string;
    background?: string;
    fontFamily?: string;
    borderRadius?: number;
  } = {};

  @Input() hoverStyles?: {
    background?: string;
  };

  private mouseEnterListener?: () => void;
  private mouseLeaveListener?: () => void;


  constructor(private el: ElementRef, private renderer: Renderer2, public ls: LayoutService) {}

  
  ngOnInit() {
    this.setBaseStyles();

    this.applyStyles(this.baseStyles);

    if (this.hoverStyles) {
      this.mouseEnterListener = this.renderer.listen(this.el.nativeElement, 'mouseenter', () => {
        const isSelected = this.el.nativeElement.getAttribute('selected') === 'true';
        if (!isSelected) {
            this.applyStyles(this.hoverStyles!);
        }
       
      });

      this.mouseLeaveListener = this.renderer.listen(this.el.nativeElement, 'mouseleave', () => {
        const isSelected = this.el.nativeElement.getAttribute('selected') === 'true';
        if (!isSelected) {
            this.applyStyles(this.baseStyles);
        }
    });
    }

 

 
  }

  
 
  ngOnDestroy() {
    this.mouseEnterListener?.();
    this.mouseLeaveListener?.();
   
  }
 
  private setBaseStyles() {
       
        this.baseStyles = {
            color: this.ls.restaurantWidgetSettings$?.value?.WidgetCustomization?.AvailableButtonColor,
            background:this.ls.restaurantWidgetSettings$?.value?.WidgetCustomization?.AvailableButtonBackgroundColor,
            fontFamily: this.ls.restaurantWidgetSettings$?.value?.WidgetCustomization?.HeaderFont,
            borderRadius: this.ls.restaurantWidgetSettings$?.value?.WidgetCustomization?.ButtonStyle === 'Rounded' ? 5 : 0
        };

        this.hoverStyles = {
            background: this.ls.restaurantWidgetSettings$?.value?.WidgetCustomization?.AvailableButtonHoverBackgroundColor
        };
    }

  
  private applyStyles(styles: {
    color?: string;
    background?: string;
    fontFamily?: string;
    borderRadius?: number;
  }) {
    if (styles.color) {
      this.renderer.setStyle(this.el.nativeElement, 'color', styles.color);
    }
    if (styles.background) {
      this.renderer.setStyle(this.el.nativeElement, 'background', styles.background);
    }
    if (styles.fontFamily) {
      this.renderer.setStyle(this.el.nativeElement, 'font-family', styles.fontFamily);
    }
    if (styles.borderRadius) {
      this.renderer.setStyle(this.el.nativeElement, 'border-radius', styles.borderRadius);
    }
  }
}
